<template>
  <div class="body">
    <div class="container">
      <div class="img">
        <img src="img/bg.svg" />
      </div>

      <div class="login-content">
        <form
        style="background-color:#ffffff"
          class="form uk-box-shadow-medium uk-padding uk-border-rounded"
          @submit.prevent="login"
        >
          <div class="uk-alert-danger uk-animation-slide-top-small" uk-alert v-if="error">
            <a class="uk-alert-close" uk-close v-on:click="error = false"></a>
            <p>
              Votre identifiant est invalide ou vous n'avez pas accès à cette
              section. Veuillez contacter l'administration
            </p>
          </div>
          <img src="img/logow.png" />
          <h2 class="title uk-margin-remove-bottom">BIENVENUE</h2>
          <p class="uk-margin-remove">sur le backoffice</p>
          <p></p>
          <div class="input-div one">
            <div class="i">
              <i class="uk-margin-small-right" style="color: #000000" uk-icon="icon:mail; ratio: 1.5"></i>
            </div>
            <div class="div">
              <input type="text" class="input" v-model="form.email" placeholder="Votre email"/>
            </div>
          </div>
          <div class="input-div pass">
            <div class="i">
               <i class="uk-margin-small-right" style="color: #000000" uk-icon="icon:lock; ratio: 1.5"></i>
            </div>
            <div class="div">
              <input type="password" class="input" v-model="form.password" placeholder="Votre mot de passe"/>
            </div>
          </div>
          <!-- <a class="a uk-padding" href="#">Mot de passe oublié?</a> -->          
          <input type="submit" class="thebtn" value="Connexion" v-if="load==false"/>
          <div><br><span class="uk-margin-small-right " uk-spinner="ratio: 1.5" v-if="load==true"></span></div>
          <!-- <input @click="googleSignIn" class="thebtn" v-if="load==false" value="Google Auth"/> -->
          <!-- <p class="uk-text-small" v-if="getRole == 5">
            Vous n'êtes pas encore inscrit ?
            <a href="/register" class="uk-text-success">S'inscrire ici</a>
          </p> -->
        </form>
      </div>
    </div>
  </div>
</template>
<script>

import firebase from "firebase";
import "firebase/auth";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      role: null,
      error: null,
      load: false,
      getRole :0,
      role:"",
    };
  },
  async created() {
    this.getRole =  this.$store.getters.user.data.role;
    if(this.getRole == 0){
       this.role = 'client'
    } else if(this.getRole == 1){
       this.role = 'livreur'
    } else if(this.getRole == 2){
       this.role = 'commercial'
    } else if(this.getRole == 3){
       this.role = 'superviseur'
    } else if(this.getRole == 4){
       this.role = 'logisticien'
    } else if(this.getRole == 5){
       this.role = 'administrateur'
    } else{
      return this.role = 'Erreur Système'
    }
  },
  methods: {
    login() {
      this.load = true;
      firebase
        .auth()
        .signInWithEmailAndPassword(this.form.email, this.form.password)
        .then((user) => {
           firebase.auth().currentUser.getIdTokenResult()
            .then((idTokenResult) => {
              if (!!idTokenResult.claims.admin || !!idTokenResult.claims.logisticien || !!idTokenResult.claims.superviseur || !!idTokenResult.claims.commercial) {
                    const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 6000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                      toast.addEventListener("mouseenter", Swal.stopTimer);
                      toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                  });
                  Toast.fire({
                    icon: "success",
                    title: '<span style="color:#34B76E">Vous êtes connecté</span>',
                  });
                  this.load = false;
                  this.$router.push({ path: "admin/livraison/encours" }).then(()=>{
                   location.reload(); 
                  });
                  location.reload();
              } else {
                firebase.auth().signOut();
                this.error = true;
                this.load = false;
              }
            }).catch((error) => {
                console.log(error);
            });
        })
        .catch((err) => {
          this.error = true;
          this.load = false;
          console.log(err)  
        });
    },
    // googleSignIn() {
    //   let provider = new firebase.auth.GoogleAuthProvider();
    //   firebase
    //     .auth()
    //     .signInWithPopup(provider)
    //     .then(result = admin => {
    //       firebase.auth().currentUser.getIdTokenResult()
    //       let token = result.credential.accessToken;
    //       let user = result.user;
    //         console.log(token) // Token
    //         console.log(user) // User that was authenticated
    //         this.$router.push({ path: "admin/livraison/encours" })
    //     })
    //     .catch((err) => {
    //       console.log(err); // This will give you all the information needed to further debug any errors
    //     });

    // },
    googleSignIn() {
      let provider = new firebase.auth.GoogleAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        .then((user) => {
          firebase.auth().currentUser.getIdTokenResult()
          .then((idTokenResult = admin) => {

          })
        })
        .catch((err) => {
          console.log(err); // This will give you all the information needed to further debug any errors
        });

    }
  },
  mounted: function () {
    const inputs = document.querySelectorAll(".input");

    function addcl() {
      let parent = this.parentNode.parentNode;
      parent.classList.add("focus");
    }

    function remcl() {
      let parent = this.parentNode.parentNode;
      if (this.value == "") {
        parent.classList.remove("focus");
      }
    }

    inputs.forEach((input) => {
      input.addEventListener("focus", addcl);
      input.addEventListener("blur", remcl);
    });
  },
};
</script>

<style>
.title,
.input-title,
h5,
p,
a,
input,
h1,
h3,
h4,
form,
label,
b,
h2,option, select, button, div,li,
.btn,
.thbtn,
ul
b-list-group-item,
input[submit] {
  font-family: "Poppins", sans-serif !important;
}
.uk-input, .uk-select{
    border: 1px solid #eee;
    background-color: #eee;
    border-radius: 8px;
    width: 100%;
    padding: 12px 12px 12px 48px;
    box-sizing: border-box;
    font-size: 16px;
 }
.title {
  font-weight: 600;
}

.wave {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 100%;
  z-index: -1;
}

.container {
  width: 100vw;
  height: 100vh;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 7rem;
  padding: 0 2rem;
}

.img {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.login-content {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
}

.img img {
  width: 500px;
}

form .form {
  width: 360px;
}

.login-content img {
  height: 100px;
}

.login-content h2 {
  margin: 15px 0;
  color: #333;
  text-transform: uppercase;
  font-size: 2.9rem;
}

.login-content .input-div {
  position: relative;
  display: grid;
  grid-template-columns: 7% 93%;
  margin: 25px 0;
  padding: 5px 0;
  border-bottom: 2px solid #d9d9d9;
}

.login-content .input-div.one {
  margin-top: 0;
}

.i {
  color: #d9d9d9;
  display: flex;
  justify-content: center;
  align-items: center;
}

.i i {
  transition: 0.3s;
}

.input-div > div {
  position: relative;
  height: 45px;
}

.input-div > div > h5 {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  font-size: 18px;
  transition: 0.3s;
}

.input-div:before,
.input-div:after {
  content: "";
  position: absolute;
  bottom: -2px;
  width: 0%;
  height: 2px;
  background-color: #38d39f;
  transition: 0.4s;
}

.input-div:before {
  right: 50%;
}

.input-div:after {
  left: 50%;
}

.input-div.focus:before,
.input-div.focus:after {
  width: 50%;
}

.input-div.focus > div > h5 {
  top: -5px;
  font-size: 15px;
}

.input-div.focus > .i > i {
  color: #38d39f;
}

.input-div > div > input {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background: none;
  padding: 0.5rem 0.7rem;
  font-size: 1.2rem;
  color: #555;
  font-family: "poppins", sans-serif;
}

.input-div.pass {
  margin-bottom: 4px;
}

a .a {
  display: block;
  text-align: right;
  text-decoration: none;
  color: #999;
  font-size: 0.9rem;
  transition: 0.3s;
}

a .a:hover {
  color: #38d39f;
}

.thebtn {
  display: block;
  width: 100%;
  height: 50px;
  border-radius: 25px;
  outline: none;
  border: none;
  background-image: linear-gradient(to right, #32be8f, #38d39f, #32be8f);
  background-size: 200%;
  font-size: 1.2rem;
  color: #fff;
  font-family: "Poppins", sans-serif;
  text-transform: uppercase;
  margin: 1rem 0;
  cursor: pointer;
  transition: 0.5s;
}
.thebtn:hover {
  background-position: right;
}

@media screen and (max-width: 1050px) {
  .container {
    grid-gap: 5rem;
  }
}

@media screen and (max-width: 1000px) {
  form .form {
    width: 290px;
  }

  .login-content h2 {
    font-size: 2.4rem;
    margin: 8px 0;
  }

  .img img {
    width: 400px;
  }
}

@media screen and (max-width: 900px) {
  .container-login {
    grid-template-columns: 1fr;
  }

  .img {
    display: none;
  }

  .wave {
    display: none;
  }

  .login-content {
    justify-content: center;
  }
}
</style>